import { usePagination, useSort } from '@energy-stacks/core/ui';
import { ESPageLoadingIndicator, RefetchOnError } from '@energy-stacks/shared';
import { useReducer, useRef } from 'react';
import {
  FilterAction,
  FiltersState,
} from '../../protocol-v1.6/logs/OcppMessageLogsTable';
import { useOcppMessageLogs } from '../../logs/useOcppMessageLogs';
import { OcppMessageLogsTableV201 } from './OcppMessageLogsTableV201';

const initialFilters: FiltersState = {
  dateRange: undefined,
  messageDirectionFilter: undefined,
  ocppActionFilter: undefined,
};

const filtersReducer = (state: FiltersState, action: FilterAction) => {
  const { type, payload } = action;
  switch (type) {
    case 'FILTER_DATE':
      return {
        ...state,
        dateRange: payload?.dateRange,
      };
    case 'FILTER_MESSAGE_DIRECTION':
      return {
        ...state,
        messageDirectionFilter: payload?.messageDirectionFilter,
      };
    case 'FILTER_OCPP_ACTION':
      return {
        ...state,
        ocppActionFilter: payload?.ocppActionFilter,
      };
    case 'FILTER_MESSAGE_TYPE':
      return {
        ...state,
        messageTypeFilter: payload?.messageTypeFilter,
      };
    case 'RESET':
      return {
        ...initialFilters,
      };
    default:
      return state;
  }
};

export const ChargingStationDetailsLogsTabV201 = () => {
  const { sorting, setSorting, sortOrder } = useSort('timestamp');
  const { pagination, setPagination } = usePagination();
  const [filtersState, dispatchFilter] = useReducer(
    filtersReducer,
    initialFilters
  );
  const { ocppMessageLogs, isError, isLoading, refetch, isFetching } =
    useOcppMessageLogs({
      filterDate: {
        timeFrom: filtersState.dateRange?.startDate,
        timeTo: filtersState.dateRange?.endDate,
      },
      messageType: filtersState.messageTypeFilter,
      messageDirection: filtersState.messageDirectionFilter,
      ocppAction: filtersState.ocppActionFilter,
      pagination: {
        page: pagination.pageIndex,
        size: pagination.pageSize,
      },
      sort: { order: sortOrder },
    });
  const logsAccessDateTime = useRef(new Date());

  if (isLoading) {
    return <ESPageLoadingIndicator />;
  }
  if (isError) {
    <RefetchOnError onRefetch={refetch} />;
  }

  return (
    <OcppMessageLogsTableV201
      onRefetch={refetch}
      ocppMessageLogs={ocppMessageLogs}
      pagination={pagination}
      sorting={sorting}
      isFetching={isFetching}
      onSortingChange={setSorting}
      sortOrder={sortOrder}
      onPaginationChange={setPagination}
      filtersState={filtersState}
      onFiltersChange={dispatchFilter}
      logsAccessDatetime={logsAccessDateTime.current}
      testId="messageLogs"
    />
  );
};
